function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".buildFail_svg__a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "buildFail_svg__a",
  d: "M11 13.426H.5v5.5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "buildFail_svg__a",
  d: "M.5 13.926v-5.5H3M4.5 13.426v5M16.5 18.926v4.5M14.516 18.426H23.5v5H.5v-5h8v5M11.164 11.507a5.321 5.321 0 012.693-3.944.5.5 0 01.729.581 3.943 3.943 0 00.32 3.023 1.23 1.23 0 001.233-.645.5.5 0 01.763-.108 2.39 2.39 0 01-.277 3.148"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "buildFail_svg__a",
  d: "M18.417 15.583c5.333-3.083 4.716-9.106 2.211-10.817h-.261L18.5 7.106a9.514 9.514 0 01-.014-5.879.5.5 0 00-.545-.649 9.511 9.511 0 00-7.077 4.884L9.536 4.168a.5.5 0 00-.707.01l-.023.025A7.474 7.474 0 007.45 11.5"
});

function SvgBuildFail(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default __webpack_public_path__ + "buildFail.25133.svg";
export { SvgBuildFail as ReactComponent };